import { useState } from "react";
import { SubmitButton } from "../components/shared/buttons/submit-button";
import Card from "../components/shared/card";
import Input from "../components/shared/input";
import Typography from "../components/shared/typography";
import { useAuth } from "../hooks/AuthContext";

const ForgotPasswordPage = () => {
  const { resetPassword, isLoading } = useAuth();
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await resetPassword(email);
    setIsSubmitted(true);
  };

  if (isSubmitted && !isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Card className="w-full max-w-md mx-auto" variant="cream" elevation={2}>
          <Card.Header variant="cream" className="text-center">
            <Typography variant="h3" className="text-primary">
              Check Your Email
            </Typography>
          </Card.Header>
          <Card.Body>
            <div className="text-center space-y-4">
              <Typography>
                We've sent a password reset link to {email}
              </Typography>
              <Typography className="text-sm text-gray-600">
                Please check your email and follow the instructions to reset
                your password.
              </Typography>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="w-full max-w-md mx-auto" variant="cream" elevation={2}>
        <Card.Header variant="cream" className="text-center">
          <Typography variant="h3" className="text-primary">
            Reset Password
          </Typography>
        </Card.Header>
        <Card.Body>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              id="reset-email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              fullWidth
            />
            <SubmitButton onSubmit={handleSubmit} isDisabled={!email}>
              Send Reset Link
            </SubmitButton>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
